import React, { useState } from 'react';
import { translate } from './i18n';
import type { Language } from './i18n';
import './SurveySubmitted.scss';

const SurveySubmitted: React.FC = () => {
    const [language, setLanguage] = useState<Language>('id');
    
    // Helper function to translate text
    const t = (key: string): string => translate(key, language);

    return (
        <div className="survey-submitted-container">
            <div className="page">
                <div className="language-toggle">
                    <select onChange={(e) => setLanguage(e.target.value as Language)} value={language}>
                        <option value="en" selected={language === 'en'}>{t("English")}</option>
                        <option value="id" selected={language === 'id'}>{t("Bahasa Indonesia")}</option>
                    </select>
                </div>

                <div className="header">
                    <div className="logo-container">
                        <img src="/logo-white.svg" alt="Logo MATE" className="logo" />
                    </div>
                    <h1>
                        {language === 'en' ? (
                            <>Korean Learning <span className="gradient-text">Profile</span> Survey</>
                        ) : (
                            <>Survei Profil Belajar Bahasa <span className="gradient-text">Korea</span></>
                        )}
                    </h1>
                </div>
                <div className="slogan">{t("Talk and Learn Korean")}</div>

                <div className="success-content">
                    <div className="success-icon">✓</div>
                    <h2>{t("Survey Submitted Successfully!")}</h2>
                    <p>{t("Thank you for submitting your Korean Learning Profile. Your tutor will review this information before your first session.")}</p>
                    <p>{t("You'll be contacted soon with next steps for your Korean language journey.")}</p>
                    
                    <div className="next-steps">
                        <h3>{t("What's Next?")}</h3>
                        <ul>
                            <li>{t("Your tutor will review your profile")}</li>
                            <li>{t("You'll receive a confirmation email within 24-48 hours")}</li>
                            <li>{t("We'll schedule your first session based on your preferences")}</li>
                        </ul>
                    </div>
                    
                    <div className="contact-info">
                        <p>{t("If you have any questions, please contact us at:")}</p>
                        <p><a href="mailto:contact@makekoreanfriends.com">contact@makekoreanfriends.com</a></p>
                    </div>
                    
                    <div className="home-button">
                        <a href="/" className="button">{t("Return to Home")}</a>
                    </div>
                </div>

                <div className="footer">
                    <p><span className="gradient-text">MATE</span> - {"Talk and Learn Korean"}</p>
                    <p>{t("We look forward to helping you on your Korean language journey.")}</p>
                </div>
            </div>
        </div>
    );
};

export default SurveySubmitted;